<template>
  <element>
    <nav-breadcrumb :menu="[{label: '意向进件'}, {label: '审核&授信'}]"/>
    <el-row>
      <el-col class="grid-content bg-purple">
        <el-steps :active="1000" class="step-shenpi">
          <el-step :title="'客户送审'"  :description="$moment((customerDetail.t__applicationDate||{})).format('YYYY-MM-DD HH:mm:ss')">
            <i class="step-start" slot="icon"></i>
          </el-step>

          <el-step v-for="(item, idx) in (customerDetail.approvals||[]).filter(item=>item.a__approvingDate)" class="step-spec" :description="$moment(item.a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(item.a__approvingStatus)" :key="idx" >
            <i class="step-mid" slot="icon" v-if="item.a__approvalType!='reStart'"></i>
            <div  v-if="item.a__approvalType!='reStart'" slot="title">{{Status2CN(item.a__nodeName)}} <br />{{item.a__approverName}}</div>
            <i class="step-start" slot="icon" v-if="item.a__approvalType=='reStart'"></i>
            <div  v-if="item.a__approvalType=='reStart'" slot="title">{{Status2CN(item.a__nodeName)}}</div>
          </el-step>

          <el-step :title="'完成'" v-if="customerDetail.t__applicationStatus == 'Approved'" >
            <i class="step-over" slot="icon"></i>
          </el-step>
          <el-step :title="'完成'" v-if="customerDetail.t__applicationStatus == 'Completed'" >
            <i class="step-over" slot="icon"></i>
          </el-step>
        </el-steps>

        <el-tabs v-model="tabName">
          <template>
            <el-tab-pane label="客户信息" name="CustomerSummary">
              <panel label="基本信息">
                <form-build
                  :form-data="customerDetail"
                  :form-rules="dataFormRules"
                  :form-columns="customerColumns"
                  class="formTable"
                  form-name="formSubmit2" ref="formBuildName2"
                />
              </panel>
              <panel label="证件图片" class="zhengjianxinxi">
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.pic__customerICFront" prefix="images/"></image-upload>
                  <label>本人身份证正面<span class="color-danger">*</span></label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.pic__customerICBack" prefix="images/"></image-upload>
                  <label>本人身份证反面<span class="color-danger">*</span></label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.pic__customerHukou1" prefix="images/"></image-upload>
                  <label>本人户口本主页<span class="color-danger">*</span></label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.pic__customerHukou2" prefix="images/"></image-upload>
                  <label>本人户口本<span class="color-danger">*</span></label>
                </div>

                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.pic__marriageCert" prefix="images/"></image-upload>
                  <label>结婚证明</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.pic__spouseICFront" prefix="images/"></image-upload>
                  <label>配偶身份证正面</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.pic__spouseICBack" prefix="images/"></image-upload>
                  <label>配偶身份证反面</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.pic__divorceCert" prefix="images/"></image-upload>
                  <label>离婚证</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.pic__singleCert" prefix="images/"></image-upload>
                  <label>单身证明</label>
                </div>

              </panel>
              <panel label="银行流水和征信证明等附件" class="zhengjianxinxi">

                <div class="zhenjianyyzz zhenjianyyzz2">
                  <file-upload  v-model="customerDetail.att__bankStatement" prefix="images/"></file-upload>
                  <label>借款人银行流水</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <file-upload  v-model="customerDetail.att__creditReport" prefix="images/"></file-upload>
                  <label>征信报告<span class="color-danger">*</span></label>
                </div>
                  <div class="zhenjianyyzz zhenjianyyzz2">
                      <file-upload  v-model="customerDetail.pic__marriageCertII"></file-upload>
                      <label>婚档</label>
                  </div>
                  <div class="zhenjianyyzz zhenjianyyzz2">
                      <file-upload  v-model="customerDetail.att__bizFile"></file-upload>
                      <label>经营佐证</label>
                  </div>
                  <div class="zhenjianyyzz zhenjianyyzz2">
                      <file-upload  v-model="customerDetail.att__miscFile"></file-upload>
                      <label>其他资料</label>
                  </div>
              </panel>

            </el-tab-pane>
            <el-tab-pane label="抵押房屋" name="House">
              <panel label="房屋信息">
                 <!-- <div style="text-align: left;padding-top: 10px">
                      <el-button type="primary" size="mini" @click="addData()">添加</el-button>
                  </div>-->
                  <panel :label="'抵押物'+(idx+1)"  v-for="(item, idx) in customerDetail.properties" :key="idx" >
                      <!--<div style="text-align: right;padding-top: 10px">
                          <el-button type="primary" size="mini" @click="deleteData(idx)">删除</el-button>
                      </div>-->
                      <!--<panel :label=""  v-for="(itemP, idxP) in item.pr__owners" :key="idxP" >
                          <form-build
                              :form-data="itemP"
                              :form-rules="fangRulesP"
                              :form-columns="houseColumnsP"
                              class="formTable"
                          />
                      </panel>-->
                      <div v-for="(itemP, idxP) in item.pr__owners" :key="idxP">
                          <form-build
                              :form-data="itemP"
                              :form-rules="fangRulesP"
                              :form-columns="houseColumnsP"
                              class="formTable"
                          />
                          <br/>
                          <br/>
                      </div>

                    <form-build
                      :form-data="item"
                      :form-rules="fangRules"
                      :form-columns="houseColumns"
                      class="formTable"
                    />
                      <panel class="zhengjianxinxi">
                      <div class="zhenjianyyzz zhenjianyyzz2">
                          <image-upload  v-model="item.pr__propertyCert" prefix="images/"></image-upload>
                          <label>房产证<span class="color-danger">*</span></label>
                      </div>
                      <div class="zhenjianyyzz zhenjianyyzz2">
                          <image-upload  v-model="item.pr__propertyLand" prefix="images/"></image-upload>
                          <label>土地证</label>
                      </div>
                      <div class="zhenjianyyzz zhenjianyyzz2">
                          <image-upload  v-model="item.pr__propertyLogbook" prefix="images/"></image-upload>
                          <label>产调<span class="color-danger">*</span></label>
                      </div>
                      </panel>
                      <data-table
                          :table-data="{data:item.pr__values, propertyIdx:idx}"
                          :columns="columns"
                          :page.sync="page"
                          :filters.sync="filters"
                          :actions="actions"
                          :isPaginationShow="false"
                          ref="tableForm"
                      />
                      <div class="totalltxt tr of">
                          平均值： {{pjdjArr[idx]|formatMoney}}
                      </div>
                      <form-build
                          :form-data.sync="item"
                          :form-rules="customerRules2"
                          :form-columns="asmColumns2"
                          class="formTable"
                      />
                  </panel>
              </panel>

            </el-tab-pane>
            <el-tab-pane label="共借人" name="borrower">
              <panel>
                <el-checkbox true-label="true" false-label="false" label="共借人1" v-model="customerDetail.coborrowers[0].co__checked"></el-checkbox>
                <panel class="zhengjianxinxi" v-if="customerDetail.coborrowers[0].co__checked=='true'||customerDetail.coborrowers[0].co__checked==true">
                <form-build
                  :form-data.sync="customerDetail.coborrowers[0]"
                  :form-rules="coRules"
                  :form-columns="coColumns"
                  class="formTable"
                  form-name="coSubmit1" ref="coBuildName1"
                  v-if="customerDetail.coborrowers[0].co__checked=='true'||customerDetail.coborrowers[0].co__checked==true"
                />
                </panel>
                <panel class="zhengjianxinxi" v-if="customerDetail.coborrowers[0].co__checked=='true'||customerDetail.coborrowers[0].co__checked==true">
                <div class="zhenjianyyzz zhenjianyyzz2"  v-if="customerDetail.coborrowers[0].co__checked=='true'||customerDetail.coborrowers[0].co__checked==true">
                  <image-upload  v-model="customerDetail.coborrowers[0].co__borrowerICFront" prefix="images/"></image-upload>
                  <label>本人身份证正面<span class="color-danger">*</span></label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2"   v-if="customerDetail.coborrowers[0].co__checked=='true'||customerDetail.coborrowers[0].co__checked==true">
                  <image-upload  v-model="customerDetail.coborrowers[0].co__borrowerICBack" prefix="images/"></image-upload>
                  <label>本人身份证反面<span class="color-danger">*</span></label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                    <file-upload  v-model="customerDetail.coborrowers[0].co__borrowerHukou1"></file-upload>
                    <label>户口本</label>
                </div>
                </panel>
              </panel>
              <panel>
                <el-checkbox true-label="true" false-label="false" label="共借人2" v-model="customerDetail.coborrowers[1].co__checked"></el-checkbox>
                <panel class="zhengjianxinxi" v-if="customerDetail.coborrowers[1].co__checked=='true'||customerDetail.coborrowers[1].co__checked==true">
                <form-build
                  :form-data.sync="customerDetail.coborrowers[1]"
                  :form-rules="coRules"
                  :form-columns="coColumns"
                  class="formTable"
                  form-name="coSubmit2" ref="coBuildName2"
                  v-if="customerDetail.coborrowers[1].co__checked=='true'||customerDetail.coborrowers[1].co__checked==true"
                />
                </panel>
                <panel class="zhengjianxinxi" v-if="customerDetail.coborrowers[1].co__checked=='true'||customerDetail.coborrowers[1].co__checked==true">
                <div class="zhenjianyyzz zhenjianyyzz2"  v-if="customerDetail.coborrowers[1].co__checked=='true'||customerDetail.coborrowers[1].co__checked==true">
                  <image-upload  v-model="customerDetail.coborrowers[1].co__borrowerICFront" prefix="images/"></image-upload>
                  <label>本人身份证正面<span class="color-danger">*</span></label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2"  v-if="customerDetail.coborrowers[1].co__checked=='true'||customerDetail.coborrowers[1].co__checked==true">
                  <image-upload  v-model="customerDetail.coborrowers[1].co__borrowerICBack" prefix="images/"></image-upload>
                  <label>本人身份证反面<span class="color-danger">*</span></label>
                </div>
                    <div class="zhenjianyyzz zhenjianyyzz2">
                        <file-upload  v-model="customerDetail.coborrowers[1].co__borrowerHukou1"></file-upload>
                        <label>户口本</label>
                    </div>
                </panel>
              </panel>
              <panel>
                <el-checkbox true-label="true" false-label="false" label="共借人3" v-model="customerDetail.coborrowers[2].co__checked"></el-checkbox>
                <panel class="zhengjianxinxi" v-if="customerDetail.coborrowers[2].co__checked=='true'||customerDetail.coborrowers[2].co__checked==true">
                <form-build
                  :form-data.sync="customerDetail.coborrowers[2]"
                  :form-rules="coRules"
                  :form-columns="coColumns"
                  class="formTable"
                  form-name="coSubmit3" ref="coBuildName3"
                  v-if="customerDetail.coborrowers[2].co__checked=='true'||customerDetail.coborrowers[2].co__checked==true"
                />
                </panel>
                <panel class="zhengjianxinxi" v-if="customerDetail.coborrowers[2].co__checked=='true'||customerDetail.coborrowers[2].co__checked==true">
                <div class="zhenjianyyzz zhenjianyyzz2"  >
                  <image-upload  v-model="customerDetail.coborrowers[2].co__borrowerICFront" prefix="images/"></image-upload>
                  <label>本人身份证正面<span class="color-danger">*</span></label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2"  >
                  <image-upload  v-model="customerDetail.coborrowers[2].co__borrowerICBack" prefix="images/"></image-upload>
                  <label>本人身份证反面<span class="color-danger">*</span></label>
                </div>
                    <div class="zhenjianyyzz zhenjianyyzz2">
                        <file-upload  v-model="customerDetail.coborrowers[2].co__borrowerHukou1"></file-upload>
                        <label>户口本</label>
                    </div>
                </panel>
              </panel>
              <panel>
                <el-checkbox true-label="true" false-label="false" label="共借人4" v-model="customerDetail.coborrowers[3].co__checked"></el-checkbox>
                <panel class="zhengjianxinxi" v-if="customerDetail.coborrowers[3].co__checked=='true'||customerDetail.coborrowers[3].co__checked==true">
                  <form-build
                    :form-data.sync="customerDetail.coborrowers[3]"
                    :form-rules="coRules"
                    :form-columns="coColumns"
                    class="formTable"
                    form-name="coSubmit4" ref="coBuildName4"
                    v-if="customerDetail.coborrowers[3].co__checked=='true'||customerDetail.coborrowers[3].co__checked==true"
                  />
                </panel>
                <panel class="zhengjianxinxi" v-if="customerDetail.coborrowers[3].co__checked=='true'||customerDetail.coborrowers[3].co__checked==true">
                  <div class="zhenjianyyzz zhenjianyyzz2"  >
                    <image-upload  v-model="customerDetail.coborrowers[3].co__borrowerICFront" prefix="images/"></image-upload>
                    <label>本人身份证正面<span class="color-danger">*</span></label>
                  </div>
                  <div class="zhenjianyyzz zhenjianyyzz2"  >
                    <image-upload  v-model="customerDetail.coborrowers[3].co__borrowerICBack" prefix="images/"></image-upload>
                    <label>本人身份证反面<span class="color-danger">*</span></label>
                  </div>
                    <div class="zhenjianyyzz zhenjianyyzz2">
                        <file-upload  v-model="customerDetail.coborrowers[3].co__borrowerHukou1"></file-upload>
                        <label>户口本</label>
                    </div>
                </panel>
              </panel>
              <panel>
                <el-checkbox true-label="true" false-label="false" label="共借人5" v-model="customerDetail.coborrowers[4].co__checked"></el-checkbox>
                <panel class="zhengjianxinxi" v-if="customerDetail.coborrowers[4].co__checked=='true'||customerDetail.coborrowers[4].co__checked==true">
                  <form-build
                    :form-data.sync="customerDetail.coborrowers[4]"
                    :form-rules="coRules"
                    :form-columns="coColumns"
                    class="formTable"
                    form-name="coSubmit5" ref="coBuildName5"
                    v-if="customerDetail.coborrowers[4].co__checked=='true'||customerDetail.coborrowers[4].co__checked==true"
                  />
                </panel>
                <panel class="zhengjianxinxi" v-if="customerDetail.coborrowers[4].co__checked=='true'||customerDetail.coborrowers[4].co__checked==true">
                  <div class="zhenjianyyzz zhenjianyyzz2"  >
                    <image-upload  v-model="customerDetail.coborrowers[4].co__borrowerICFront" prefix="images/"></image-upload>
                    <label>本人身份证正面<span class="color-danger">*</span></label>
                  </div>
                  <div class="zhenjianyyzz zhenjianyyzz2"  >
                    <image-upload  v-model="customerDetail.coborrowers[4].co__borrowerICBack" prefix="images/"></image-upload>
                    <label>本人身份证反面<span class="color-danger">*</span></label>
                  </div>
                    <div class="zhenjianyyzz zhenjianyyzz2">
                        <file-upload  v-model="customerDetail.coborrowers[4].co__borrowerHukou1"></file-upload>
                        <label>户口本</label>
                    </div>
                </panel>
              </panel>
            </el-tab-pane>
            <el-tab-pane  label="收款银行账户" name="bank">
              <panel class="zhengjianxinxi">
                <el-checkbox true-label="true" false-label="false" label="暂时无法提供" v-model="customerDetail.bank"></el-checkbox>
                <form-build
                  :form-data.sync="customerDetail"
                  :form-rules="bankRules"
                  :form-columns="bankColumns"
                  class="formTable"
                  form-name="formSubmit4" ref="formBuildName4"
                />
              </panel>
              <panel class="zhengjianxinxi">
                <div class="zhenjianyyzz zhenjianyyzz2" >
                  <image-upload  v-model="customerDetail.pic__customerBankCardFront" prefix="images/"></image-upload>
                  <label>银行卡正面</label>
                </div>
              </panel>
            </el-tab-pane>
          </template>
        </el-tabs>

        <panel label="评估信息">

          <form-build
            :form-data.sync="customerDetail"
            :form-rules="customerRules"
            :form-columns="asmColumns"
            class="formTable"
            form-name="formSubmit1" ref="formBuildName1"
          />
        </panel>
          <panel label="风控材料（包含房价、法务、一账通，产调等相关信息）" class="zhengjianxinxi">
              <div class="zhenjianyyzz zhenjianyyzz2">
                  <file-upload  v-model="customerDetail.asr__attachment1" prefix="images/"></file-upload>
                 <span class="color-danger">*</span>
              </div>
          </panel>
      </el-col>
    </el-row>
    <div class="tr xzmt">
      <el-button type="primary" @click="onSave()">暂存</el-button>
      <el-button type="primary" @click="onSubmit('Approved')">审核通过</el-button>
      <el-button type="" @click="onSubmit2('Rejected')">否决</el-button>
    </div>
    <el-dialog
      title="房价跟踪"
      :visible.sync="dialogVisible"
      width="45%">
      <house-history-price-component @getPrice="onGetPrice"></house-history-price-component>
    </el-dialog>
    </element>
</template>

<script>
  import xhr from '../../utils/xhr'
  import Status2CN from "../../filters/Status2CN";
  import moment from 'moment'
  import Panel from "../../components/Panel";
  import HouseHistoryPriceComponent from "../components/HouseHistoryPriceComponent";
  import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "CustomerApplyingApproveKF",
      components: {HouseHistoryPriceComponent, Panel},
      data(){
          return {
              hangyeOptions:[],
              regionOptions:[],
              propertyIdx:0,
              initStatus: false,
            customerRules: {

                asr__approvedAmount: [
                  {
                    required: true,
                    message: '核定贷款金额不能为空！'
                  }
                ],
              },
            customerRules2: {
              asm__pledgeExAmount:[
                  {
                      required: false,
                      message: '一抵余额不能为空！'
                  }
              ],
                asm__pledgeGrade:[
                    {
                        required: true,
                        message: '抵押顺位不能为空！'
                    }
                ],
              asm__assessedUnitValue: [
                  {
                      required: true,
                      message: '评估单价不能为空！'
                  }
              ],
              asm__assessedTotalValue: [
                  {
                      required: true,
                      message: '实际评估价不能为空！'
                  }
              ],
              asm__pledgeRate: [
                  {
                      required: true,
                      max:100,
                      message: '抵押率不能为空！'
                  }
              ],
          },
            bankRules: {
              ba__customerBankAccountNo: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ba__customerBankName: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
            },
            bankColumns:[
              {
                label: '户名',
                field: 'ba__customerName',
                type: 'text',
              },
              {
                label: '账号',
                field: 'ba__customerBankAccountNo',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '开户银行',
                field: 'ba__customerBankName',
                component: 'el-input',
                type: 'text',
                span:24
              },
            ],
            fangRules: {
              pr__propertyOwner: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              pr__propertyLocation: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              pr__propertyUsage: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              pr__propertyArea: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              pr__propertyCertNo: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              /*ex__propertyLandNo: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],*/
            },
            fangRulesP: {
              ow__ownerName: [
                  {
                      required: true,
                      message: '不能为空！'
                  }
              ],
            },
            houseColumnsP:[
                {
                    label: '序号',
                    field: 'ow__lineNo',
                    component: 'el-input',
                    type: 'number',
                    span:24
                },
              {
                  label: '姓名',
                  field: 'ow__ownerName',
                  component: 'el-input',
                  type: 'text',
              },
              {
                  label: '身份证号',
                  field: 'ow__ownerIC',
                  component: 'el-input',
                  type: 'text',
              },
              {
                  label: '手机号',
                  field: 'ow__ownerContactNo',
                  component: 'el-input',
                  span:24
              },
              {
                  label: '住所地址',
                  field: 'ow__ownerAddress',
                  component: 'el-input',
                  span:24
              },
          ],
            productOptions :[],
            unit:'',
            coRules:{
              co__relationship: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              co__borrowerName: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              co__borrowerIC: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              co__borrowerContactNo: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
            },
            coColumns:[
              {
                label: '与借款人关系',
                field: 'co__relationship',
                component: 'el-select',
                options:[
                  {
                    label:'配偶',
                    value:'配偶'
                  },
                  {
                    label:'父母',
                    value:'父母'
                  },
                  {
                    label:'兄弟',
                    value:'兄弟'
                  },
                  {
                    label:'姐妹',
                    value:'姐妹'
                  },
                  {
                    label:'子女',
                    value:'子女'
                  },
                  {
                    label:'朋友',
                    value:'朋友'
                  },
                  {
                    label:'其他',
                    value:'其他'
                  },
                ]
              },
              {
                label: '姓名',
                field: 'co__borrowerName',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '身份证号码',
                field: 'co__borrowerIC',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '手机号',
                field: 'co__borrowerContactNo',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '住所地址',
                field: 'co__borrowerAddress',
                component: 'el-input',
                type: 'text',
                span:24
              },
            ],
            tabName: 'CustomerSummary',
            applicationId: this.$route.query['applicationId']||'',
            customerDetail:{
              bank:'true',
              approvals:[],
              coborrowers:[{},{},{},{},{}],
                properties:[
                    {
                        pr__owners:[]
                    }
                ],
            },
            dataFormRules:{
                t__regionId: [
                    {
                        required: true,
                        message: '不能为空！'
                    }
                ],
                ex__industryId: [
                    {
                        required: true,
                        message: '不能为空！'
                    }
                ],
              ba__customerName: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ba__customerIC: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ex__customerDOB: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ba__customerContactNo: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ex__customerSex: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ex__customerJiguan: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ex__customerHukou: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ex__customerAddress: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ex__customerMartialStatus: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ba__amount: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ba__productId: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ba__interestRate: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ba__repaymentCount: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
            },
            houseColumns:[
                {
                    label: '用途',
                    field: 'pr__propertyUsage',
                    component: 'el-select',
                    options:[
                        {
                            label:'住宅（自建房）',
                            value:'住宅（自建房）'
                        },
                        {
                            label:'住宅（商品房）',
                            value:'住宅（商品房）'
                        },
                        {
                            label:'住宅（安置房）',
                            value:'住宅（安置房）'
                        },
                        {
                            label:'商用',
                            value:'商用'
                        },
                        {
                            label:'商住两用',
                            value:'商住两用'
                        }
                    ],
                },
              {
                label: '位置',
                field: 'pr__propertyLocation',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '产权证号',
                field: 'pr__propertyCertNo',
                component: 'el-input',
                type: 'text',
              },
                {
                    label: '面积',
                    field: 'pr__propertyArea',
                    component: 'el-input',
                    type: 'number',
                    props: {
                        step: 0.01
                    },
                    unit:'㎡'
                },
                {
                    label: '土地使用权面积',
                    field: 'pr__propertyLandArea',
                    component: 'el-input',
                    type: 'number',
                    props: {
                        step: 0.01
                    },
                    unit:'㎡'
                },
              {
                label: '土地证',
                field: 'pr__propertyLandNo',
                component: 'el-input',
                type: 'text',
              },
            ],

            page: 1,
            pageSize: 20,
            actions: [
              {
                label: '最新房价',
                class: 'el-button--primary',
                clickHandler: t=>{
                  this.dialogVisible = true
                    this.propertyIdx = t.data.propertyIdx
                }
              },
              {
                label: '新增',
                class: 'el-button--primary',
                clickHandler: t=>{
                   // console.log(t)
                    t.data.push({})
                }
              }
            ],
            filters: {
              form: {

              },
              columns: [

              ]
            },
            tableData :{
              count: 0,
              data: [
                {
                  pv__ckecked:'true',
                  pv__source:'',
                  pv__quote: '',
                },
              ]
            },
            columns:[
              {
                label: '序号',
                type: 'index'
              },
              {
                label: '查询渠道',
                field: 'pv__source',
                component: 'el-input',
                type: 'text',
                rules: [
                  {
                    required: true,
                    message: '查询渠道不能为空',
                    trigger: 'blur'
                  },
                ]
              },
              {
                label: '挂牌单价',
                field: 'pv__quote',
                component: 'el-input',
                type: 'number',
                rules: [
                  {
                    required: true,
                    message: '挂牌单价不能为空',
                    trigger: 'blur'
                  },
                ],
                unit:'元/㎡',
              },
              {
                label: '操作',
                opts:[
                  {
                    label: '删除',
                    class: 'el-icon-delete',
                    clickHandler:(index, row,  t)=>{
                      //  console.log(t)
                      t.data.splice(index, 1)
                    }
                  }
                ]
              }
            ],
            dialogVisible: false
          }
        },
      mounted() {
          this.getApplyingCustomerFang()
         /* this.getAdministrativeRegion()*/

      },
      computed:{
            /**
             * [1,2,3,4,5,6]
             */
            pjdjArr() {
                return this.customerDetail.properties.map(item=> {
                  //  console.log(item)
                    if(item.pr__values){
                        let tempArr = item.pr__values.filter(item=>item.pv__quote)

                        return tempArr.reduce((total, curr) => {
                            total = (Number(curr.pv__quote)||0) + Number(total)
                            return total
                        }, 0)/tempArr.length
                    }else{
                        return 0
                    }

                })
            },
          watchChanged() {
              return this.customerDetail.properties.map(item=>({
                  asm__assessedUnitValue: item.asm__assessedUnitValue,
                  pr__propertyArea:item. pr__propertyArea,
              }))
          },
          watchChangedTwo() {
              return this.customerDetail.properties.map(item=>({
                  asm__pledgeGrade: item.asm__pledgeGrade,
                  asm__pledgeExAmount: item.asm__pledgeExAmount,
              }))
          },
        asmColumns(){
          return [


            {
              label: '核定贷款金额',
              field: 'asr__approvedAmount',
              component: 'el-input',
              type: 'number',
              props: {
                step: 0.01
              },
              unit:'元',
                span:24
            },
            {
              label: '其他资产情况',
              field: 'asr__otherAssets',
              component: 'el-input',
              type: 'textarea',
              span:24

            },
            {
              label: '网络核查情况',
              field: 'asr__internetCheck',
              component: 'el-input',
              type: 'textarea',
              span:24

            },
            {
              label: '评估情况',
              field: 'asr__accessmentRemarks',
              component: 'el-input',
              type: 'textarea',
              span:24

            },
            {
              label: '结论',
              field: 'asr__accessmentResult',
              component: 'el-input',
              type: 'textarea',
              span:24

            },
            {
              label: '审核意见',
              field: 'a__remarks',
              component: 'el-input',
              type: 'textarea',
              span:24

            },

          ]
        },
        asmColumns2(){
              return [
                  {
                      label: '评估单价',
                      field: 'asm__assessedUnitValue',
                      component: 'el-input',
                      type: 'number',
                      props: {
                          step: 0.01
                      },
                      unit:'元/㎡'
                  },
                  {
                      label: '实际评估价',
                      field: 'asm__assessedTotalValue',
                      formatter: function (c,v) {
                          return formatMoney(v)
                      },
                      unit:'元'
                  },
                  {
                      label: '名义评估价',
                      field: 'asm__nominalTotalValue',
                      component: 'el-input',
                      type: 'number',
                      props: {
                          step: 0.01
                      },
                      unit:'元',
                      span:24
                  },
                  {
                      label: '名义评估价说明',
                      field: 'asm__nominalValueRemarks',
                      component: 'el-input',
                      type: 'textarea',
                      span:24
                  },
                  {
                      label: '抵押顺位',
                      field: 'asm__pledgeGrade',
                      component: 'el-select',
                      options:[
                          {
                              label:'一抵',
                              value:'一抵',
                          },
                          {
                              label:'二抵',
                              value:'二抵',
                          }
                      ],

                  },
                  {
                      label: '抵押率',
                      field: 'asm__pledgeRate',
                      component: 'el-input',
                      type: 'number',
                      props: {
                          step: 0.01
                      },
                      unit:'%',
                  },
                  {
                      label: '一抵余额',
                      field: 'asm__pledgeExAmount',
                      component: 'el-input',
                      type: 'number',
                      props: {
                          step: 0.01
                      },
                      unit:'元',
                      span:12
                  },
                  {
                      label: '一抵债权金额',
                      field: 'asm__pledgeRightsAmount',
                      component: 'el-input',
                      type: 'number',
                      props: {
                          step: 0.01
                      },
                      unit:'元',
                      span:12
                  },
                  {
                      label: '产调情况',
                      field: 'asm__pledgeRemarks',
                      component: 'el-input',
                      type: 'textarea',
                      span:24

                  },

              ]
          },

        customerColumns(){
          return [
            {
              label: '身份证号码',
              field: 'ba__customerIC',
              component: 'el-input',
              type: 'text',
            },
            {
              label: '客户姓名',
              field: 'ba__customerName',
              component: 'el-input',
              type: 'text',
            },
            {
              label: '性别',
              field: 'ex__customerSex',
              component: 'el-select',
              options:[
                {
                  label:'男',
                  value:'M'
                },
                {
                  label:'女',
                  value:'F'
                }
              ],

            },


            {
              label: '手机号',
              field: 'ba__customerContactNo',
              component: 'el-input',
              type: 'text',
            },
            {
              label: '出生日期',
              field: 'ex__customerDOB',
              component: 'el-date-picker',
              valueFormat: 'yyyy-MM-dd',
            },

            {
              label: '户口地区',
              field: 'ex__customerHukou',
              component: 'el-input',
              type: 'text',
            },

            {
              label: '籍贯',
              field: 'ex__customerJiguan',
              component: 'el-input',
              type: 'text',
              span:24
            },
            {
              label: '常住地址',
              field: 'ex__customerAddress',
              component: 'el-input',
              span:24
            },

            {
              label: '婚姻状况',
              field: 'ex__customerMartialStatus',
              component: 'el-select',
              options:[
                {
                  label:'已婚',
                  value:'已婚'
                },
                {
                  label:'未婚',
                  value:'未婚'
                },
                {
                  label:'离异',
                  value:'离异'
                },
                {
                  label:'丧偶',
                  value:'丧偶'
                }
              ]
            },
          {
              label: '行业类型',
              field: 'ex__industryId',
              component: 'el-cascader',
              props:{
                  emitPath:false,
                  showAllLevels:false,
                  expandTrigger:'hover',
                  clearable:true,
                  multiple:true

              },
             options:this.hangyeOptions
          },
            {
              label: '配偶姓名',
              field: 'ex__spouseName',
              component: 'el-input',
              type: 'text',
            },
            {
              label: '配偶身份证号码',
              field: 'ex__spouseIC',
              component: 'el-input',
              type: 'text',
            },
            {
              label: '配偶手机',
              field: 'ex__spouseContactNo',
              component: 'el-input',
              type: 'text',

            },
              {
                  label: '配偶户口',
                  field: 'ex__spouseHukou',
                  component: 'el-input',
                  type: 'text',
              },
              {
                  label: '配偶生日',
                  field: 'ex__spouseDOB',
                  component: 'el-date-picker',
                  valueFormat: 'yyyy-MM-dd'
              },

              {
                  label: '配偶籍贯',
                  field: 'ex__spouseJiguan',
                  component: 'el-input',
                  type: 'text',
              },
            {
              label: '申贷金额',
              field: 'ba__amount',
              component: 'el-input',
              type: 'number',
              props: {
                step: 0.01
              },
              unit:'元',
              span:12,
            },
            {
              label: '贷款产品',
              field: 'ba__productId',
              component: 'el-select',
              options: this.productOptions,
            },
            {
              label: '贷款利率',
              field: 'ba__interestRate',
              component: 'el-input',
              type: 'number',
              props: {
                step: 0.01
              },
              unit:this.unit

            },
            {
              label: '还款期数（月）',
              field: 'ba__repaymentCount',
                component: 'el-input',
                type: 'number',
              props: {
                step: 1
              }
            },
              {
                  label: '业务城市',
                  field: 't__regionName',
                /*  component: 'el-select',
                  options: this.regionOptions,
                  span:24*/
              },
            {
              label: '贷款用途',
              field: 'ex__purpose',
              component: 'el-input',
              type:"textarea",
              span:24
            },
            {
              label: '客户来源',
              field: 'ba__channel',
            },

            {
              label: '分配渠道商',
              field: 'd__dealerName'
            },
            {
              label: '进件人',
              field: 'jinjian__userName'
            },
            {
              label: '渠道商审核人员',
              field: 'chushen__userName'
            },


          ]
         },
        numberAverage: function () {
            let arr = this.tableData.data.map(item=>item.pv__quote).filter(item=>item)
            return (arr.reduce(
              (total,curr)=> {
                total += Number(curr)||0
                return total
              }, 0
            ) / arr.length)||0
          }
      },
      watch:{
          watchChanged:function () {
              if(!this.initStatus) return
              else {

                  this.changeValue()
              }
          },
          watchChangedTwo:function () {
              if(!this.initStatus) return
              else {

                  this.changeValue2()
              }
          },
        /*'customerDetail.t__regionId':function (newVal) {
            if(this.regionOptions.length>0) {
                 this.customerDetail.t__regionName= (this.regionOptions.filter(item => item.value == newVal)[0] || {}).label
            }
        },*/
        'customerDetail.ba__amount':function () {
            if(!this.initStatus) return
            else {

                this.changeValue()
            }
        },

        'customerDetail.asr__approvedAmount':function () {
            if(!this.initStatus) return
            else {

                this.changeValue()
                this.customerDetail.ba__amount  =this.customerDetail.asr__approvedAmount
            }

        },
      /* 'customerDetail.asm__pledgeExAmount':function () {
           this.changeValue()
        },*/
        'customerDetail.ba__productId':function (newVal) {
          if(this.productOptions.length>0) {
            // let lendingFee = (this.productOptions.filter(item=>item.value== newVal)[0]||{}).p__lendingFee
            let interestRate = (this.productOptions.filter(item => item.value == newVal)[0] || {}).dp__interestRate
            // let lendingFeeType = (this.productOptions.filter(item=>item.value== newVal)[0]||{}).p__lendingFeeType
            let interestType = (this.productOptions.filter(item => item.value == newVal)[0] || {}).dp__interestType
            let repaymentCount = (this.productOptions.filter(item => item.value == newVal)[0] || {}).p__repaymentCount

            this.customerDetail.ba__repaymentCount = repaymentCount
            this.customerDetail.ba__interestRate = interestRate
            this.customerDetail.ba__productName = (this.productOptions.filter(item => item.value == newVal)[0] || {}).p__productName

            if (interestType == 'Yearly') {
              this.unit = "%（年利率）"
            }
            if (interestType == 'Daily') {
              this.unit = "%（日利率）"
            }
            if (interestType == 'Monthly') {
              this.unit = "%（月利率）"
            }
            this.customerDetail.ba__interestType = interestType
          }
          /*if(lendingFeeType=='Rate'){
            if(this.financingDetail.fi__totalAmount){
              this.financingDetail.fi__lendingFee = this.financingDetail.fi__totalAmount*lendingFee/100
            }
          }else{
            this.financingDetail.fi__lendingFee = lendingFee
          }*/

        },
      },
      methods: {
          getIndustry:function(parentId,options){
              xhr.getIndustry(
                  Object.assign({
                      pageSize:0
                  }, {},{}),
                  res=> {
                      try {
                              res.data.data.forEach(item=>{

                                  let option = {
                                  }
                                  if(item.i__parentId==null){

                                      option.label = item.i__name
                                      option.value = item.i__industryId
                                      console.log(option)
                                      res.data.data.forEach(item1=>{
                                          if(item.i__industryId == item1.i__parentId){

                                              if(option.children){

                                              }else{
                                                  option.children = []
                                              }
                                              let option1 = {
                                              }
                                              option1.label = item1.i__name
                                              option1.value = item1.i__industryId
                                              res.data.data.forEach(item2=>{
                                                  if(item1.i__industryId == item2.i__parentId){
                                                      if(option1.children){

                                                      }else{
                                                          option1.children = []
                                                      }
                                                      option1.children.push({
                                                          label:item2.i__name,
                                                          value:item2.i__industryId,
                                                      })
                                                  }
                                              })
                                              option.children.push(option1)

                                          }
                                      })
                                      console.log(option)
                                      options.push(option)
                                  }

                                  /*xhr.getIndustry(
                                      Object.assign({
                                          parentId:item.i__industryId,
                                          pageSize:0
                                      }, {},{}),
                                      res1=> {
                                          try {
                                              let childrenOptions = []



                                              if(res1.data.count>0){
                                                  this.getIndustry(item.i__industryId,childrenOptions)
                                                  options.push({
                                                      label:item.i__name,
                                                      value:item.i__industryId,
                                                      children:childrenOptions
                                                  })
                                              }else{
                                                  options.push({
                                                      label:item.i__name,
                                                      value:item.i__industryId,
                                                  })

                                              }

                                          }catch(e){


                                          }
                                      })*/

                                })
                      }catch(e){

                      }
                  })

          },
          addData: function () {
              this.customerDetail.properties.push({pr__values:[]})
          },
          deleteData:function(index){
              this.customerDetail.properties.splice(index, 1)
          },
          addValues:function(values){
              values.push({})
          },
        changeValue : function(){
           // this.customerDetail.ba__amount = 0
            let approvedAmounts = parseFloat(this.customerDetail.asr__approvedAmount)
            let assessedTotalValue = 0
            this.customerDetail.properties.forEach(item=>{
               // console.log(item)
                item.asm__assessedTotalValue = item.asm__assessedUnitValue * item.pr__propertyArea
                //名义评估价默认实际评估价的1.3倍以万元取整
                item.asm__nominalTotalValue = (Math.floor(((1.3* item.asm__assessedTotalValue) / 10000))* 10000).toFixed(2)



                item.asm__pledgeRate = null
                assessedTotalValue = assessedTotalValue +(parseFloat(item.asm__assessedTotalValue)||0)
                if(item.asm__pledgeGrade=='一抵'){
                    if(item.asm__assessedTotalValue&&this.customerDetail.asr__approvedAmount&&this.customerDetail.asr__approvedAmount!=0){
                     //   item.asm__pledgeRate = (100*parseFloat(this.customerDetail.asr__approvedAmount)/parseFloat(item.asm__assessedTotalValue)).toFixed(2)
                    }

                }else{
                    if(item.asm__assessedTotalValue&&this.customerDetail.asr__approvedAmount&&item.asm__pledgeExAmount&&this.customerDetail.asr__approvedAmount!=0){
                      //  item.asm__pledgeRate = (100*(parseFloat(this.customerDetail.asr__approvedAmount)+parseFloat(item.asm__pledgeExAmount))/parseFloat(item.asm__assessedTotalValue)).toFixed(2)
                        approvedAmounts = approvedAmounts +parseFloat(item.asm__pledgeExAmount)
                    }
                }
            })
            this.customerDetail.properties.forEach(item=>{
                if(assessedTotalValue>0){
                    item.asm__pledgeRate = (100*approvedAmounts/assessedTotalValue).toFixed(2)
                }

            })

            this.customerDetail.properties = this.customerDetail.properties

        },
          changeValue2 : function(){
              // this.customerDetail.ba__amount = 0
              let approvedAmounts = parseFloat(this.customerDetail.asr__approvedAmount)
              let assessedTotalValue = 0
              this.customerDetail.properties.forEach(item=>{

                  assessedTotalValue = assessedTotalValue +(parseFloat(item.asm__assessedTotalValue)||0)
                  if(item.asm__pledgeGrade=='一抵'){
                      if(item.asm__assessedTotalValue&&this.customerDetail.asr__approvedAmount&&this.customerDetail.asr__approvedAmount!=0){
                          //   item.asm__pledgeRate = (100*parseFloat(this.customerDetail.asr__approvedAmount)/parseFloat(item.asm__assessedTotalValue)).toFixed(2)
                      }

                  }else{
                      if(item.asm__assessedTotalValue&&this.customerDetail.asr__approvedAmount&&item.asm__pledgeExAmount&&this.customerDetail.asr__approvedAmount!=0){
                          //  item.asm__pledgeRate = (100*(parseFloat(this.customerDetail.asr__approvedAmount)+parseFloat(item.asm__pledgeExAmount))/parseFloat(item.asm__assessedTotalValue)).toFixed(2)
                          approvedAmounts = approvedAmounts +parseFloat(item.asm__pledgeExAmount)
                      }
                  }
              })
              this.customerDetail.properties.forEach(item=>{
                  if(assessedTotalValue>0){
                      item.asm__pledgeRate = (100*approvedAmounts/assessedTotalValue).toFixed(2)
                  }

              })


              this.customerDetail.properties = this.customerDetail.properties

          },
        Status2CN,
        getFinanceProductFangList: function () {
          xhr.getFinanceProductFangList(
            Object.assign({
              'd.dealerId':this.customerDetail.ba__dealerId
            }, {}, {}),
            res=> {
              try {
                this.productOptions = []
                this.productOptions = res.data.data.map(item=>{
                  return {
                    label: item.p__productName,
                    value:item.p__productId,
                    'dp__interestRate':item.dp__interestRate,
                    'dp__interestType':item.dp__interestType,
                    'p__productName':item.p__productName,
                    'p__repaymentCount':item.p__repaymentCount,
                  }

                })
                this.customerColumns[13].options = this.productOptions||[]
                //console.log( this.productOptions  )
              }catch(e){

              }
            })

        },
          getAdministrativeRegion: function () {
              xhr.getAdministrativeRegion(
                  Object.assign({pageSize :0
                  }, {}, {}),
                  res=> {
                      try {
                          this.regionOptions = res.data.data.map(item=>{
                              return {
                                  label: item.r__province+'/'+item.r__city+'/'+item.r__district,
                                  value:item.r__regionId,
                              }

                          })
                      }catch(e){

                      }
                  })

          },
        getApplyingCustomerFang : function () {
            xhr.getApplyingCustomerFang({
              't.applicationId': this.$route.query['applicationId']
            }, res=>{
              try{
                if(res.data.status == 'success') {
                    console.log()
                    const customerDetail = res.data.data
                    customerDetail.properties.forEach(item=> {

                        if(item.asm__nominalTotalValue){

                        }else{
                            item.asm__nominalTotalValue = null
                        }

                        if(item.asm__pledgeRate){

                        }else{
                            item.asm__pledgeRate = null
                        }

                        if(item.asm__assessedUnitValue){

                        }else{
                            item.asm__assessedUnitValue = null
                        }

                        if(item.asm__nominalValueRemarks){

                        }else{
                            item.asm__nominalValueRemarks = null
                        }


                        if(item.asm__pledgeExAmount){

                        }else{
                            item.asm__pledgeExAmount = 0
                        }

                        if(item.asm__pledgeRightsAmount){

                        }else{
                            item.asm__pledgeRightsAmount = null
                        }

                        if(item.asm__pledgeRemarks){

                        }else{
                            item.asm__pledgeRemarks = null
                        }

                        if(item.asm__pledgeGrade){

                        }else{
                            item.asm__pledgeGrade = null
                        }


                    })
                  //  customerDetail.ex__industryId = customerDetail.ex__industryId.split(',')
                  this.customerDetail = customerDetail
                    this.customerDetail .asr__approvedAmount = this.customerDetail.ba__amount
                  if( this.customerDetail.ba__customerBankAccountNo){
                    this.$set(this.customerDetail, 'bank', 'false')
                  }else{
                    this.$set(this.customerDetail, 'bank', 'true')
                  }

                    if( this.customerDetail.a__remarks){
                    }else{
                        this.$set(this.customerDetail, 'a__remarks', '')
                    }

                 // this.tableData.data = this.customerDetail.values
                  if( this.customerDetail.ba__dealerId) {
                    this.getFinanceProductFangList()
                  }

                  let length = this.customerDetail.coborrowers.length
                  for(var i=0;i<5-length;i++){
                    this.customerDetail.coborrowers.push(
                      {
                        'co__checked':'false'
                      }
                    )
                  }
                  //console.log(this.customerDetail.coborrowers)
                  let interestType =  this.customerDetail.ba__interestType

                  if(interestType=='Yearly'){
                    this.unit="%（年利率）"
                  }
                  if(interestType=='Daily'){
                    this.unit="%（日利率）"
                  }
                  if(interestType=='Monthly'){
                    this.unit="%（月利率）"
                  }
                    this.getIndustry(null,this.hangyeOptions)
              /*
                  if(this.customerDetail.c__applicationStatus=="Pending Approval"){
                    this.getApplyCustomerCreditDetail(this.creditId);
                  }*/
                    /*this.customerDetail.properties[0].pr__owners=[
                        {
                            ow__ownerName:1,
                            ow__ownerIC:1,
                            ow__ownerAddress:1,
                            ow__ownerContactNo:1,
                            ow__ownerAddress:1
                        },
                        {
                            ow__ownerName:1,
                            ow__ownerIC:1,
                            ow__ownerAddress:1,
                            ow__ownerContactNo:1,
                            ow__ownerAddress:1
                        },
                        {
                            ow__ownerName:1,
                            ow__ownerIC:1,
                            ow__ownerAddress:1,
                            ow__ownerContactNo:1,
                            ow__ownerAddress:1
                        }
                    ]*/
                    let approvals = []
                    for(var i=0;i<this.customerDetail.approvals.length;i++){
                        approvals.push(this.customerDetail.approvals[i])
                        if(this.customerDetail.approvals[i].a__approvalType=='ZJL'&&this.customerDetail.approvals[i].a__approvingStatus=='Approved'&&i<this.customerDetail.approvals.length-1){
                            approvals.push({
                                'a__nodeName':'reStart',
                                'a__approvingDate':this.customerDetail.approvals[i].a__approvingDate,
                                'a__approvingStatus':''
                            })
                        }
                    }
                    this.customerDetail.approvals = approvals
              this.$nextTick(()=> {
                  this.initStatus = true
              })


                }
              }catch(e){}
            })
          },
        onSave :function () {
            this.customerDetail.properties.forEach(item=>{
                item.pr__values.forEach(item1=>{
                    item1.pv__checked = true
                })
                item.pr__values = item.pr__values.filter(item=>item.pv__source)
            })
          this.customerDetail.properties.forEach(item=>{
              item.properties__checked = true
              item.pr__checked = true
              item.pr__owners.forEach(itemP=>{
                  itemP.ow__checked = true
              })
              if(item.asm__assessedUnitValue){

              }else{
                  item.asm__assessedUnitValue =0
              }
              if(item.asm__pledgeExAmount){

              }else{
                  item.asm__pledgeExAmount = 0
              }
              if(item.asm__pledgeRate){

              }else{
                  item.asm__pledgeRate = 0
              }
              if(item.asm__pledgeRightsAmount){

              }else{
                  item.asm__pledgeRightsAmount = 0
              }
          //    console.log(item.asm__nominalTotalValue)
          })

            if(Array.isArray(this.customerDetail.ex__industryId)){
                this.customerDetail.ex__industryId =  this.customerDetail.ex__industryId[ this.customerDetail.ex__industryId.length-1]
            }
          xhr.AddApplyingCustomerInfo(
            this.customerDetail,
            res=> {
              try{
                if(res.data.status == 'success') {

                }else{

                  this.$message.error(res.data.msgs[0].text)
                }
                this.$router.push({
                  path: 'List'
                })
              }catch (e) {

                this.$message.error(error.msgs[0].text)

              }
            }
          )

        },
        onSubmit :function (status) {
        //  this.customerDetail.values = this.tableData.data
          this.customerDetail.a__approvingStatus = status
           /* this.customerDetail.properties.forEach(item=>{
                item.pr__values.forEach(item1=>{
                    item1.pv__checked = true
                })
                item.pr__values = item.pr__values.filter(item=>item.pv__source)
            })*/
          this.$refs.formBuildName1.$refs.formSubmit1.validate(valid1=> {
            if(valid1){
              this.$refs.formBuildName2.$refs.formSubmit2.validate(valid2=> {
                if(valid2){
                  if(!(this.customerDetail.pic__customerICFront&&
                    this.customerDetail.pic__customerICBack&&
                    this.customerDetail.pic__customerHukou1&&
                    this.customerDetail.att__creditReport&&
                      this.customerDetail.asr__attachment1&&
                    this.customerDetail.pic__customerHukou2)){
                    this.$alert('有必填的图片或pdf未上传')
                    return false
                  }
                  let next = true
                  this.$refs.coBuildName1 && this.$refs.coBuildName1.$refs.coSubmit1.validate(valid4=> {
                    if (valid4) {
                      if(!(this.customerDetail.coborrowers[0].co__borrowerICFront&&this.customerDetail.coborrowers[0].co__borrowerICBack)){
                        this.$alert('共借人1有必填的图片未上传')
                        next =  false
                      }
                    }else{
                      next =  false
                    }
                  })
                  this.$refs.coBuildName2 && this.$refs.coBuildName2.$refs.coSubmit2.validate(valid5=> {
                    if(!(this.customerDetail.coborrowers[1].co__borrowerICFront&&this.customerDetail.coborrowers[1].co__borrowerICBack)){
                      this.$alert('共借人2有必填的图片未上传')
                      next =  false
                    }
                    if (valid5) {
                    }else{
                      next =  false
                    }
                  })

                  this.$refs.coBuildName3 && this.$refs.coBuildName3.$refs.coSubmit3.validate(valid6=> {
                    if (valid6) {
                      if(!(this.customerDetail.coborrowers[2].co__borrowerICFront&&this.customerDetail.coborrowers[2].co__borrowerICBack)){
                        this.$alert('共借人3有必填的图片未上传')
                        next =  false
                      }
                    }else{
                      next =  false
                    }
                  })

                  this.$refs.coBuildName4 && this.$refs.coBuildName4.$refs.coSubmit4.validate(valid8=> {
                    if (valid8) {
                      if(!(this.customerDetail.coborrowers[3].co__borrowerICFront&&this.customerDetail.coborrowers[3].co__borrowerICBack)){
                        this.$alert('共借人4有必填的图片未上传')
                        next =  false
                      }
                    }else{
                      next =  false
                    }
                  })

                  this.$refs.coBuildName5 && this.$refs.coBuildName5.$refs.coSubmit5.validate(valid9=> {
                    if (valid9) {
                      if(!(this.customerDetail.coborrowers[4].co__borrowerICFront&&this.customerDetail.coborrowers[4].co__borrowerICBack)){
                        this.$alert('共借人5有必填的图片未上传')
                        next =  false
                      }
                    }else{
                      next =  false
                    }
                  })

                  if(!(this.customerDetail.bank=='true')) {
                    this.$refs.formBuildName4.$refs.formSubmit4.validate(valid7 => {
                      if (valid7) {

                      } else {
                        next = false
                      }
                    })
                  }
                  let coborrower = true
                  let customerIC = this.customerDetail.ba__customerIC
                  let customerContactNo = this.customerDetail.ba__customerContactNo

                  let coborrowers = this.customerDetail.coborrowers

                  for(var i=0;i<coborrowers.length;i++){
                    if(coborrowers[i].co__checked == 'true'){
                      let ic= coborrowers[i].co__borrowerIC
                      let no= coborrowers[i].co__borrowerContactNo
                      if(customerIC==ic||customerContactNo ==no){
                        coborrower  = false
                      }
                      if(i<coborrowers.length-1){
                        for(var j=i+1;j<coborrowers.length;j++){
                          if((coborrowers[j].co__borrowerIC==ic||coborrowers[j].co__borrowerContactNo ==no)&&coborrowers[j].co__checked == 'true'){
                            coborrower  = false
                          }
                        }
                      }
                    }
                  }
                  if(!coborrower){
                    this.$alert('存在重复的手机号或身份证号')
                  }
                  if(this.customerDetail.asr__approvedAmount>   this.customerDetail.properties.reduce((total, curr) => {
                      total = (Number(curr.asm__assessedTotalValue)||0) + Number(total)
                      return total
                  }, 0)){
                    this.$alert('核定贷款金额不能大于实际评估价')
                    next = false
                  }

                    if(this.customerDetail.ba__amount>   this.customerDetail.properties.reduce((total, curr) => {
                        total = (Number(curr.asm__nominalTotalValue )||0)-(Number(curr.asm__pledgeRightsAmount   )||0) + Number(total)
                        return total
                    }, 0)){
                        this.$alert('抵押物可贷金额低于申贷金额！')
                        next = false
                    }


                    let proper = true
                    let properties = this.customerDetail.properties

                    for(var i=0;i<properties.length;i++){
                        let owners =properties[i].pr__owners
                        for(var m=0;m<owners.length;m++){
                            if(!owners[m]){
                                this.$alert('抵押物存在权属人名称未填写')
                                proper = false
                            }
                        }
                        properties[i].pr__checked = true
                        //let propertyOwner= properties[i].pr__propertyOwner
                        let propertyLocation= properties[i].pr__propertyLocation
                        let propertyUsage= properties[i].pr__propertyUsage
                        let propertyArea= properties[i].pr__propertyArea
                        let propertyCertNo= properties[i].pr__propertyCertNo
                        let propertyCert= properties[i].pr__propertyCert
                        let propertyLogbook= properties[i].pr__propertyLogbook


                        let assessedUnitValue= properties[i].asm__assessedUnitValue
                        let pledgeRate= properties[i].asm__pledgeRate
                        let assessedTotalValue= properties[i].asm__assessedTotalValue
                        if(properties[i].asm__pledgeRightsAmount==null){
                            properties[i].asm__pledgeRightsAmount=0
                        }
                        if(!(propertyLocation&&propertyUsage&&propertyArea&&propertyCertNo&&propertyCert&&propertyLogbook&&assessedUnitValue&&pledgeRate&&assessedTotalValue)){
                            this.$alert('抵押物存在必填项未填写')
                            proper = false
                        }

                        if(parseFloat(properties[i].asm__nominalTotalValue) < parseFloat((Math.floor(((1.3* properties[i].asm__assessedTotalValue) / 10000))* 10000).toFixed(2))&&(properties[i].asm__nominalValueRemarks==null||properties[i].asm__nominalValueRemarks.replace(/^\s+|\s+$/g,"")=='')){
                            this.$alert('名义评估价低于实际评估价的1.3倍，请填写详细的名义评估价说明')
                            next = false
                        }



                        if(properties[i].asm__pledgeGrade=='二抵'){

                            if(properties[i].asm__pledgeExAmount<=0){
                                this.$alert('一抵余额必须大于0')
                                next = false
                            }
                            if(properties[i].asm__pledgeRightsAmount<=0){
                                this.$alert('一抵债权金额大于0')
                                next = false
                            }


                        }else{
                            //properties[i].asm__pledgeExAmount = 0
                        }
                        /*if(this.customerDetail.asm__pledgeGrade=='二抵'){
                            this.customerRules.asm__pledgeExAmount = [
                                {
                                    required: true,
                                    message: '一抵余额不能为空！'
                                }
                            ]
                            // console.log(this.customerRules.asm__pledgeExAmount)
                        }else{
                            this.customerRules.asm__pledgeExAmount = [
                                {
                                    required: false,
                                    message: '一抵余额不能为空！'
                                }
                            ]
                        }*/

                        if(i<properties.length-1&&proper){
                            for(var j=i+1;j<properties.length;j++){
                                if(properties[j].pr__propertyLocation==propertyLocation){
                                    proper  = false
                                    this.$alert('抵押物'+(i+1)+'与抵押物'+(j+1)+'的位置不能重复')
                                }
                                if(properties[j].pr__propertyCertNo==propertyCertNo){
                                    proper  = false
                                    this.$alert('抵押物'+(i+1)+'与抵押物'+(j+1)+'的产权证号不能重复')
                                }
                            }
                        }

                    }
                    if(Array.isArray(this.customerDetail.ex__industryId)){
                        this.customerDetail.ex__industryId =  this.customerDetail.ex__industryId[ this.customerDetail.ex__industryId.length-1]
                    }
                  if(next&&coborrower&&proper){
                      xhr.updateApproveCustomerFangEdit(
                        this.customerDetail,
                        res=> {
                          try{
                            if(res.data.status == 'success') {

                            }else{

                              this.$message.error(res.data.msgs[0].text)
                            }
                            this.$router.push({
                              path: 'List'
                            })
                          }catch (e) {

                            this.$message.error(error.msgs[0].text)

                          }
                        }
                      )
                  }
                }
              })
            }
          })

        },
        onSubmit2 :function (status) {
        //  this.customerDetail.values = this.tableData.data
          this.customerDetail.a__approvingStatus = status
            this.customerDetail.properties.forEach(item=>{
                item.pr__values.forEach(item1=>{
                    item1.pv__checked = true
                })
                item.pr__values = item.pr__values.filter(item=>item.pv__source)
            })

            this.customerDetail.properties.forEach(item=>{
                if(item.asm__pledgeGrade=='二抵'){

                }else{
                    item.asm__pledgeExAmount = 0
                }
                if(item.asm__pledgeRightsAmount==null){
                    item.asm__pledgeRightsAmount=0
                }
            })

            xhr.updateApproveCustomerFangEdit(
              this.customerDetail,
              res=> {
                try{
                  if(res.data.status == 'success') {

                  }else{

                    this.$message.error(res.data.msgs[0].text)
                  }
                  this.$router.push({
                    path: 'List'
                  })
                }catch (e) {

                  this.$message.error(error.msgs[0].text)

                }
              }
            )

        },
        onGetPrice: function (priceList) {
          this.dialogVisible = false
          this.customerDetail.properties[this.propertyIdx].pr__values = Object.keys(priceList).reduce( (prev, curr) => {
            prev.push({
              pv__source: curr,
              pv__quote: priceList[curr]
            })
            return prev
          }, [])
       //   console.log(priceList)
            this.propertyIdx = 0
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/CustomerApplyingApproveKF.vue